import { createSlice } from "@reduxjs/toolkit";
import { getLogRequestResponse } from "./actions/logRequestResponse";

const initialState = {
    logRequestResponseReport: null,
    total: 0,
    loading: false,
    pageState: { page: 1, pageSize: 50 },
};

export const logRequestResponseSlice = createSlice({
    name: "logRequestResponseReport",
    initialState,
    reducers: {
        setRequestResponsePage: (state, action) => {
            const { page, pageSize } = action.payload;
            if (page) {
                state.pageState = {
                    ...state.pageState,
                    page,
                };
            }
            if (pageSize) {
                state.pageState = {
                    ...state.pageState,
                    pageSize,
                };
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getLogRequestResponse.pending, (state) => {
                state.loading = true;
            })
            .addCase(getLogRequestResponse.fulfilled, (state, action) => {
                const { data, count } = action.payload;
                state.loading = false;
                state.logRequestResponseReport = data;
                state.total = count;
            })
            .addCase(getLogRequestResponse.rejected, (state) => {
                state.loading = false;
            });
    },
});

export const { setRequestResponsePage } = logRequestResponseSlice.actions;

export default logRequestResponseSlice.reducer;
